import { RedoCheckbox } from "@redotech/arbiter/checkbox/redo-checkbox";

export function LimitOncePerCustomerField({
  value,
  setValue,
}: {
  value: boolean;
  setValue: (value: boolean) => void;
}) {
  return (
    <RedoCheckbox
      label="Limit to 1 use per customer"
      setValue={(value) => setValue(value === true)}
      size="xs"
      value={value}
    />
  );
}
